<template>
  <div class="multiple-choice">
    <van-checkbox-group :value="issue.select" checked-color="var(--theme-color)">
      <div class="items-group mb-3 last:mb-0" v-for="(group, index) in issue.item_groups" :key="index">
        <div class="cg-title text-base break-words">
          <span> {{ group.title }}</span>
        </div>
        <ul class="cg-content">
          <li
            v-for="item in group.options"
            :key="item.id"
            class="mb-2 last:mb-0 choice-item-wrap"
            :class="{ selected: issue.select.includes(item.id) }"
          >
            <multiple-choice-item
              :value="issue.select"
              :item="item"
              @click="onChangeValue"
              :correct-answer-list="correctAnswerList"
            />
            <template v-if="issue.select.includes(item.id)">
              <div class="px-2">
                <relation-input
                  :type="item.inputType"
                  v-if="item.is_other_item"
                  v-model="item.value"
                  class="my-2"
                  :question-type="question.questionType"
                  :question-id="question.id"
                  :option-id="item.id"
                  :enable-relation="item.setting.enableRelation"
                  :max-length="item.maxLength"
                  :min-length="item.minLength"
                  :validate="item.validate"
                  :allow-error-list="item.allowErrorList"
                  :placeholder="item.placeholder"
                />
                <!--                <van-field :type="item.inputType" v-if="item.is_other_item" v-model="item.value" class="my-2" />-->
              </div>
              <adapter-upload-files :content="item.content" class="my-2" />
            </template>
            <vote-progress
                v-if="showVoteProgress && changeExpr"
                :vote="question.vote"
                :label="item.id"
                :checked="issue.select.includes(item.id)"
                :selected="!!issue.select.length"
            />
          </li>
        </ul>
      </div>
    </van-checkbox-group>
  </div>
</template>

<script>
import MultipleChoiceItem from '@/questions/components/MultipleChoiceItem'
import AdapterUploadFiles from '@/questions/components/AdapterUploadFiles'
import RelationInput from '../components/RelationInput'
import { Notify } from 'vant'
import VoteProgress from '../components/VoteProgress.vue'

export default {
  name: 'MultipleChoice',
  components: { VoteProgress, RelationInput, AdapterUploadFiles, MultipleChoiceItem },
  changeExpr: 'changeExpr',
  computed: {
    correctAnswerList() {
      if (!this.view) return []
      return this.question.getCorrectAnswerList()
    },
    changeExpr() {
      return this.issue.select
        .map(id => {
          let item = this.issue.getItemById(id)
          if (item) {
            return item.id + item.value + item.content.fileList.length
          } else {
            return ''
          }
        })
        .join('-')
    }
  },
  created() {},
  methods: {
    onChangeValue(val) {
      if (val.disabled) return
      let select = this.issue.select.slice()
      let items = this.issue.items
      let exclusiveList = this.issue.exclusiveList
      let index = select.findIndex(id => id === val.id)
      let isExclusive = !!val.is_exclusive
      if (index > -1) {
        select.splice(index, 1)
      } else {
        select.push(val.id)
      }
      if (isExclusive) {
        if (index > -1) {
          select = []
        } else {
          select = [val.id]
        }
      } else if (exclusiveList.length) {
        select = select.filter(id => !exclusiveList.includes(id))
      }
      const max = this.issue.max_choice
      if (max && max > 0) {
        if (select.length > max) {
          Notify({
            type: 'warning',
            message: `最多选择${max}项`
          })
          return
        }
      }
      this.issue.select = select
    },
    mutexHandler(group1, group2, type) {
      let list = this.issue.select

      function isSame(id) {
        return list.includes(id)
      }

      let g1 = group1[type](isSame)
      let g2 = group2[type](isSame)
      let mutexArray = []
      if (g1) {
        mutexArray = group2
      } else if (g2) {
        mutexArray = group1
      } else {
      }

      this.issue.items.forEach(item => {
        if (item.disabled) return
        item.disabled = mutexArray.includes(item.id)
        if (item.disabled) {
          let idx = list.findIndex(id => item.id === id)
          if (idx > -1) {
            list.splice(idx, 1)
          }
        }
      })
    },
    transMutex() {
      this.issue.mutex.forEach(mutex => {
        let type = mutex.mutex_type
        let group1 = mutex.mutex_group1
        let group2 = mutex.mutex_group2
        if (type === 1) {
          this.mutexHandler(group1, group2, 'every')
        } else if (type === 2) {
          this.mutexHandler(group1, group2, 'some')
        }
      })
    }
  },
  watch: {
    'issue.select'() {
      if (this.issue.mutex.length) {
        this.issue.items.forEach(item => {
          item.disabled = false
        })
        this.transMutex()
      }
    }
  }
}
</script>
